import React, { useState } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

// Define the container style for the map (full screen width and height)
const containerStyle = {
  width: "100vw",  // Full viewport width
  height: "100vh", // Full viewport height
};

// Define the default center of the map (latitude and longitude)
const center = {
  lat: 28.6448,   // Latitude for the center
  lng: 77.216721, // Longitude for the center
};

function DataCenter() {

  // State for holding the location markers on the map
  const [locationMarker] = useState([{latitude:"12.9792", longitude:"77.6501"}]);

  // Load Google Maps API script using the provided key
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA08TJWvLGvDD4cXLo-231gioXgaugKUw0", // Google Maps API key
  });

  return isLoaded ? (
    // Render the Google Map if it is loaded
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
      {/* Render markers for each location */}
      {locationMarker
        .flat() // Flatten the array of arrays into one array of marker objects
        .map((marker, index) => (
          <Marker
            key={index}  // Unique key for each marker based on the index
            name={marker.sitename}  // The name of the site (marker)
            position={{
              lat: parseFloat(marker.latitude), // Convert latitude to float for map positioning
              lng: parseFloat(marker.longitude), // Convert longitude to float for map positioning
            }}
            title={marker.sitename} // Tooltip title for the marker
          />
        ))}
    </GoogleMap>
  ) : (
    // Return an empty fragment if the map isn't loaded yet
    <></>
  );
}

// Memoize the DataCenter component to avoid unnecessary re-renders
export default React.memo(DataCenter);
